import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'BcoolStore';
const DEFAULT_DESC = "Récits vécus, chroniques et confidences — des histoires qui donnent envie de tourner la page.";
const DEFAULT_IMAGE = '/images/story-110.jpg';

/**
 * SEO wrapper : injecte les balises <head> pour référencement + partage social.
 * Usage :
 *   <SEO
 *     title="Mon article"
 *     description="Résumé..."
 *     image="/images/xxx.jpg"
 *     url="/article/mon-slug"
 *     type="article"
 *     author="Bcool"
 *     publishedTime="2026-07-16"
 *   />
 */
const SEO = ({
  title,
  description,
  image,
  url,
  type = 'website',
  author,
  publishedTime,
  keywords,
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Histoires & Confidences`;
  const desc = description || DEFAULT_DESC;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const finalUrl = url ? `${origin}${url.startsWith('/') ? url : `/${url}`}` : origin;
  const finalImage = image
    ? (image.startsWith('http') ? image : `${origin}${image}`)
    : `${origin}${DEFAULT_IMAGE}`;

  return (
    <Helmet prioritizeSeoTags>
      {/* Base tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={finalUrl} />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:locale" content="fr_FR" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={finalImage} />
    </Helmet>
  );
};

export default SEO;
